import { createNavigationView } from './index'

const ProfileSidebar = () => import('../components/Profile/ProfileSidebar.vue')

const OngoingBids = () => import('../components/OngoingBids/OngoingBids.vue')
const AdvertDetailsAuthenticator = () => import('../components/Arena/AdvertDetailsAuthenticator.vue')
const BidModalAuthenticator = () => import('../components/Arena/BidModalAuthenticator.vue')
const BidsModalAuthenticator = () => import('../components/BidSessions/BidsModalAuthenticator.vue')

export const routes = () => [
  {
    path: '/folyamatban-levo-ajanlataim',
    components: {
      default: OngoingBids,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    children: [
      {
        path: 'ajanlat/:id/elozmeny',
        component: BidsModalAuthenticator,
        props: true,
        meta: {
          isModal: true,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: 'hirdetes/:id/ajanlat',
        component: BidModalAuthenticator,
        props: true,
        meta: {
          isModal: true,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: 'hirdetes/:id',
        component: AdvertDetailsAuthenticator,
        props: route => ({ id: route.params.id }),
        meta: {
          isModal: true,
          wrapperClass: 'profile-wrapper'
        }
      }
    ],
    meta: {
      pageTitle: 'Bidded adverts',
      requiresAuth: true,
      requiresValidProfile: true,
      wrapperClass: 'profile-wrapper'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/ongoing-bids.js